import { useCallback } from "react"
import { graphql } from "relay-runtime"
import { useMutationWithErrorToast } from "@/hooks/useMutationWithErrorToast"

const clearAppointmentsMutation = graphql`
  mutation useRemoveAllAppointmentsMutation {
    removeAllAppointments {
      boolean
    }
  }
`

const clearChEpisodesOfCareMutation = graphql`
  mutation useRemoveAllAppointmentsMutationAndTheirChEpisodeOfCareRelatedDataMutation {
    ch_removeAllEpisodeOfCareRelatedData {
      boolean
    }
  }
`

const clearDeEpisodesOfCareMutation = graphql`
  mutation useRemoveAllAppointmentsMutationAndTheirDeEpisodeOfCareRelatedDataMutation {
    de_removeAllEpisodeOfCareRelatedData {
      boolean
    }
  }
`

export function useRemoveAllAppointmentsMutation() {
  const [commitChEoc, isInFlightChEoc] = useMutationWithErrorToast(clearChEpisodesOfCareMutation)
  const [commitDeEoc, isInFlightDeEoc] = useMutationWithErrorToast(clearDeEpisodesOfCareMutation)
  const [commitAppt, isInFlightAppt] = useMutationWithErrorToast(clearAppointmentsMutation)
  const isInFlight = isInFlightChEoc || isInFlightDeEoc || isInFlightAppt

  return [
    useCallback(
      (handleComplete?: () => void) => {
        commitChEoc({
          variables: {},
          onCompleted: () => {
            commitDeEoc({
              variables: {},
              onCompleted: () => {
                commitAppt({
                  variables: {},
                  onCompleted: handleComplete,
                })
              },
            })
          },
        })
      },
      [commitChEoc, commitDeEoc, commitAppt],
    ),
    isInFlight,
  ] as const
}
